import React, { useState } from "react";
import API from "../../../apis/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import "../styles/moduleStyle.css";

const Module = ({ name }) => {
  const [inputValue, setInputValue] = useState("");
  const [response, setResponse] = useState("");
  const [processing, setProcessing] = useState(false);

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
    auto_height(event.target);
  };

  const handleButtonClick = () => {
    askGPT(inputValue);
  };

  const askGPT = (text) => {
    setProcessing(true);
    console.log(`Valor do input enviado para askGPT: ${text}`);

    API.post("ai/chatgpt", {
      application: "egg",
      pergunta: text,
      estadoConversa: [],
      details: "dalle",
      callbackUrl: "",
      callbackRefId: "",
    }).then((response) => {
      let finalResponse = response.data.response;
      setResponse(finalResponse);
      setProcessing(false);
      return finalResponse;
    });
  };

  return (
    <div className="gpt-module">
      <h2>Dalle</h2>
      <textarea
        type="text"
        value={inputValue}
        rows="1"
        onChange={handleInputChange}
        placeholder="Dalle..."
      />
      <div>
        {processing ? (
          <FontAwesomeIcon icon={faSpinner} spin className="icon" />
        ) : (
          <button onClick={handleButtonClick}>Enviar</button>
        )}
      </div>
      {response && !processing && (
        <img src={response} alt="Imagem de resposta" className="responseImage" />
      )}
    </div>
  );
};

function auto_height(elem) {
  /* javascript */
  elem.style.height = "1px";
  elem.style.height = elem.scrollHeight + "px";
}

export default Module;
